import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

export const StyledMainLayout = styled.main`
  flex: 1;
  flex-direction: column;
  display: flex;
  ${({ $noGap }) => $noGap === false && `gap:${pxToRem(30)} ;`}
`
